/*
 * @Author: hujingyang
 * @Description: 绑定或修改手机号
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Button, Dialog, Icon, Input, Message } from '@alifd/next';
import styles from './index.module.scss';
import CacheUtils from '@/utils/CacheUtils';
import utils from '@/common/utils';
import { Servlets } from '@/service';
import LzMsg from '../common/LzMsg';

let timer = 0;
const CacheCodeKey = 'INDEX_SMS_CODE_TIK';
/** 数据弹窗架子 */
const Dialog_BindTelPhone = (props: any): JSX.Element => {
  const { visible, selected, bindingPhone, defaultPhone = ''} = props;
  const [countdown, setCountdown] = useState(+(CacheUtils.getItem(CacheCodeKey) || 0));
  const [storeBindPhone, setStoreBindPhone] = useState(defaultPhone||''); // 店铺绑定的手机号
  const [code, setCode] = useState<string | undefined>(undefined);
  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, [props]);

  /**
   * 初始化函数
   */
  const init = (): void => {
    utils.debounceImmediately(getPageData); // 函数防抖 - 制止组件创建时多次初始化页面
  };
  /** 获取页面 */
  const getPageData = (): void => {
    if (visible) {
      // 获取店铺绑定手机号
      Servlets('getTitle').then((res: { data: { phone: '' } }) => {
        if (!res.data) {
          return;
        }
        setStoreBindPhone(res.data.phone);
      });
    }
  };
  /** 关闭弹窗触发 */
  const onClose = (): void => {
    setStoreBindPhone('');
    setCode('');
    selected(false);
  };
  const tik = (val: number) => {
    const count = val;
    if (timer) {
      window.clearTimeout(timer);
      timer = 0;
    }
    if (count > 0) {
      setCountdown(count - 1);
      CacheUtils.setItem(CacheCodeKey, count - 1);
      timer = window.setTimeout(() => {
        tik(count - 1);
      }, 1000);
    } else {
      setCountdown(0);
      window.clearTimeout(timer);
      timer = 0;
      CacheUtils.setItem(CacheCodeKey, 0);
    }
  };
  const handleSendCode = async () => {
    try {
      tik(60);
      Servlets('setMobileSmsCode', {phoneNumber:storeBindPhone}).then((res:{success,data,resp_msg}) =>
      {
        if (res.success) {
          LzMsg.success(`验证码发送到号码为${storeBindPhone}手机`);
        }else {
          LzMsg.error(res.resp_msg);
        }
      }).catch((e) => {
        console.log(e);
        LzMsg.error(e.message);
      });
    } catch (e) {
      tik(0);
      Message.error(`验证码获取失败`);
    }
  };
  /** 提交用户修改手机号的请求 */
  const onSubmit  =  () => {
    Servlets('savePhoneNumber', {phoneNumber:storeBindPhone, code:code,activityId:'1'}).then((res:{success,data,resp_msg}) =>
    {
      if (res.success) {
        LzMsg.success('手机号码保存成功');
        setCode('');
        selected(false);
      }else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      LzMsg.error(e.message);
    });
  };
  useEffect(() => {
    if(CacheUtils.getItem(CacheCodeKey)) { // 页面刷新后继续计时
      tik(+(CacheUtils.getItem(CacheCodeKey) || 0))
    }
  }, []);
  useEffect(()=>{
    setStoreBindPhone(defaultPhone);
  },[defaultPhone])
  return (
    <>
      <section>
        <Dialog
          title={`${bindingPhone? '修改' : '绑定'}手机号`}
          visible={visible}
          footer={[
            <Button
              type="primary"
              key="submit"
              className={styles.formBtn}
              onClick={onSubmit}
            >
              确认
            </Button>,
            <Button
              key="cancel"
              onClick={onClose}
              className={styles.formBtn1}
            >
              取消
            </Button>
          ]}
          onClose={onClose}
        >
          <div>
            <div style={{ display: 'flex' }}>
              <Icon
                type="prompt"
                size="small"
                style={{ color: '#f0b447', marginRight: 8 }}
              />
              <div>
                <div>绑定手机号仅用于以下服务</div>
                <div>
                  1. 日常运营策略支持；2.
                  大促运营策略支持；3.CRM运营咨询；4.代运营能力支持；5.运营策划、实施、落地、数据分析、运营报告
                </div>
              </div>
            </div>
            <div className={styles['form-box']}>
              <span>手机号：</span>
              <div>
                <Input
                  maxLength={11}
                  value={storeBindPhone}
                  defaultValue={defaultPhone}
                  onChange={(val) => {
                    setStoreBindPhone(val);
                  }}
                  showLimitHint
                  style={{ width: 380 }}
                />
              </div>
            </div>
            <div className={styles['form-box']}>
              <span>验证码：</span>
              <div>
                <Input
                  addonAfter={
                    <Button
                      onClick={handleSendCode}
                      className={styles.SmsCodeButton}
                      disabled={!storeBindPhone.match(/1[3456789]\d{9}/) || countdown > 0}
                      style={{ height:'32px' }}
                    >
                      {countdown ? `${countdown}秒重发` : '获取验证码'}
                    </Button>
                  }
                  style={{ width: 380 }}
                  value={code}
                  onChange={setCode}
                  maxLength={6}
                  placeholder="验证码"
                />
              </div>
            </div>
          </div>
        </Dialog>
      </section>
    </>
  );
};

export default Dialog_BindTelPhone;
